import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

const openClass = 'open'

export default function init360Modal(page) {
  const modal = document.querySelector('[data-modal-360]')

  if (!modal) return

  const modalClose = modal.querySelector('[data-modal-360-close]')
  const modalOpen = page.querySelectorAll('[data-modal-360-open]')
  const iframe = modal.querySelector('[data-modal-360-iframe]')

  const close = () => {
    modal.classList.remove(openClass)
    setTimeout(() => enableBodyScroll(modal), 300)
  }

  const open = () => {
    disableBodyScroll(modal)
    modal.classList.add(openClass)
  }

  document.addEventListener('keyup', e => {
    if (e.key === 'Escape') {
      close()
    }
  })

  modalClose.addEventListener('click', close)

  modalOpen.forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault()
      open()
      if (iframe) {
        iframe.src = btn.dataset.iframeSrc
      }
    })
  })
}
